import CalculatorWrapper from './CalculatorWrapper';

export default CalculatorWrapper;